import { create } from 'zustand';

export type SnoopMode = 'listen' | 'whisper' | 'barge';

export interface ActiveSnoop {
  /** ה-channel של השיחה המנוטרת (לצורך החלפת מצב = snoop חדש). */
  channelId: string;
  /** מזהה ערוץ ה-snoop שנוצר ב-Asterisk — לניתוק יזום ("רד מהאזנה"). */
  snoopChannelId: string | null;
  mode: SnoopMode;
  agentId: number;
  agentName: string;
  /** מזהה ערוץ הצ'אט הפנימי (לפתיחת "צ'אט לנציג" מהסרגל). */
  /** מתי ההאזנה התחילה (לטיימר החי). */
  startedAt: number;
}

interface ActiveSnoopState {
  active: ActiveSnoop | null;
  /** מסמן שהמנהל בהאזנה/לחישה/הצטרפות פעילה (מציג את הסרגל הצף). */
  start: (snoop: ActiveSnoop) => void;
  /** עדכון חלקי (למשל mode אחרי החלפה, או snoopChannelId חדש). */
  update: (patch: Partial<ActiveSnoop>) => void;
  /** סוגר את הסרגל (הניתוק עצמו נעשה ע"י ה-caller מול השרת). */
  clear: () => void;
}

/**
 * מצב ה-snoop הפעיל של המנהל. חי מחוץ ל-router (כמו הצ'אט הצף/הנגן) כדי
 * שסרגל השליטה הצף (SnoopControlBar) ישרוד ניווט — המנהל יכול להאזין ולנווט
 * במקביל, ותמיד לראות "אתה מאזין ל..." + לרדת/להחליף מצב מכל מסך.
 */
export const useActiveSnoop = create<ActiveSnoopState>()((set) => ({
  active: null,
  start: (snoop) => set({ active: snoop }),
  update: (patch) => set((s) => (s.active ? { active: { ...s.active, ...patch } } : s)),
  clear: () => set({ active: null }),
}));
